import React from "react";
import "./contact.css";

function Contact() {
  return (
    <div className="contactMainContainer">
      <div className="contactContainer">
        <div className="contactTitle">
          <h2>Contactanos!</h2>
        </div>
        <div className="contactFormContainer"></div>
      </div>
    </div>
  );
}

export default Contact;
